import React from 'react'
import { useState } from 'react';
import ValidateStep1 from '../../utils/validations/nimValidations';
import ValidateFiscalFormPatient from '../../utils/validations/patientValidationsAutoBilling';
import { validateTicket, getTaxRegimeByTypePerson, DownloadInvoice, DownloadXml, getUseCfdi, sendStampIngress } from '../../services/invoice/selfBillings'
import { useRef } from "react";
import { bussineValidation, bussinePatient, rfcValidation, rfcPatient, cpValidation, cpPatient } from '../../utils/validations/messageInvoice'



export const useMicrositeSelfBillings = () => {
    const toastBC = useRef(null);

    // ? CONFIGURATION FORMS
    const [step, setStep] = useState(1);
    const [showPassword, setShowPassword] = useState(false);


    // * FORM INVOICE
    const [formSelfBiling, setFormSelfBiling] = useState({
        nim: null,
        password: null,
        date: null,
        amount: null,
        sendEmail: true,
        invoice_id: null,
        uuid: null,
        total_stamp: null,
        folio_stamp: null
    });


    // ? CONFIGURATION STEP 1
    const [validations, setValidations] = useState({});
    const [loadingValidation, setLoadingValidation] = useState(false);
    const [loadingText, setLoadingText] = useState("Validando datos...");
    const [showTicketAlert, setShowTicketAlert] = useState(false);
    const [ticketMessage, setTicketMessage] = useState("");
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);

    // ? CONFIGURATION STEP 2
    const [listTaxRegimes, setListTaxRegimes] = useState([]);
    const [loadingInvoice, setLoadingInvoice] = useState(false);
    const [loadingInvoiceText, setLoadingInvoiceText] = useState("");
    const [titleGenerateInvoice, setTitleGenerateInvoice] = useState("")
    const [isStampInvoice, setIsStampInvoice] = useState(false);
    const [listUseCFDI, setListUseCFDI] = useState([]);


    // ? CONFIGURATION STEP 3
    const [showDownloadAlert, setShowDownloadAlert] = useState(false);
    const [tittlePdf, setTittlePdf] = useState("");
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [loadingXml, setLoadingXml] = useState(false);

    // ? VALIDATIONS STEP 2
    const [validationsPatient, setValidationsPatient] = useState({
        id_tax_regime_patient_valid: false,
        rfc_patient_valid: false,
        cp_patient_valid: false,
        email_valid: false,
        business_name_patient_valid: false,
        id_use_cdfi_valid: false
    });


    // *  CONFIGURATION STEP 1 -------------

    const formatDate = (date) => {
        if (!date) return null;

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };

    const parseDate = (dateString) => {
        if (!dateString) return null;

        const [year, month, day] = dateString.split("-");
        return new Date(year, month - 1, day);
    };

    const handleChangeForm = (field, value) => {
        setFormSelfBiling((prev) => ({
            ...prev,
            [field]: field === "date" ? formatDate(value) : value
        }));

        setValidations((prev) => ({
            ...prev,
            [`${field}_valid`]: false
        }));
    };


    // ? VALIDATE SESION
    const saveStep1 = async () => {
        const validationsResponse = ValidateStep1(formSelfBiling);

        setValidations(validationsResponse?.newValidations);

        if (validationsResponse?.statusValidation) return;

        setLoadingValidation(true);

        const body = {
            nim: formSelfBiling?.nim,
            password: formSelfBiling?.password,
            date: formSelfBiling?.date
                ? formSelfBiling?.date.split("-").reverse().join("/")
                : "",
            amount: formSelfBiling?.amount
        };

        const messages = [
            "Validando datos...",
            "Consultando paciente...",
            "Verificando contraseña...",
            "Buscando comprobante...",
            "Procesando acceso..."
        ];

        let index = 0;

        setLoadingText(messages[index]);

        const startTime = Date.now();

        const interval = setInterval(() => {
            index = (index + 1) % messages.length;
            setLoadingText(messages[index]);
        }, 1500);

        try {
            const sendStamp = await validateTicket(body);

            const elapsed = Date.now() - startTime;
            const minLoadingTime = 7000;

            if (elapsed < minLoadingTime) {
                await new Promise(resolve =>
                    setTimeout(
                        resolve,
                        minLoadingTime - elapsed
                    )
                );
            }

            clearInterval(interval);
            setLoadingValidation(false);

            if (sendStamp?.code === 200) {
                localStorage.setItem("token", sendStamp.data.token);
                setShowSuccessAlert(true);
                setStep(2);
                setTimeout(() => {
                    setShowSuccessAlert(false);
                }, 5000);

            }
            else if (sendStamp?.code === 429) {
                setShowTicketAlert(true);
                setTicketMessage(
                    sendStamp?.data?.message ||
                    "No se encontró información con los datos ingresados."
                );
            }
            else if (sendStamp?.code === 400) {
                setShowTicketAlert(true);
                setTicketMessage(
                    sendStamp?.msg ||
                    "No se encontró información con los datos ingresados."
                );

            }
            else {
                setShowTicketAlert(true);
                setTicketMessage(
                    sendStamp?.data?.msg ||
                    "No se encontró información con los datos ingresados."
                );
            }
        } catch (error) {
            clearInterval(interval);
            setLoadingValidation(false);

            toastBC.current.clear();

            toastBC.current.show({
                life: 5000,
                closable: false,
                content: () => (
                    <div
                        style={{
                            width: "430px",
                            borderRadius: "24px",
                            overflow: "hidden",
                            background: "#fff",
                            boxShadow: "0 25px 60px rgba(0,0,0,.20)"
                        }}
                    >
                        <div
                            style={{
                                background:
                                    "linear-gradient(135deg,#ef4444 0%,#dc2626 100%)",
                                padding: "24px",
                                color: "#fff",
                                display: "flex",
                                alignItems: "center",
                                gap: "14px"
                            }}
                        >
                            <i
                                className="pi pi-times-circle"
                                style={{ fontSize: "2rem" }}
                            ></i>
                            <div>
                                <div
                                    style={{
                                        fontSize: "24px",
                                        fontWeight: 700
                                    }}
                                >
                                    Error
                                </div>

                                <small style={{ fontSize: "15px" }}>
                                    No se pudo conectar con el servidor
                                </small>
                            </div>
                        </div>
                    </div>
                )
            });
        }
    };


    // ! CLEAN MESAGE
    const resetInvoiceFlow = (
        message = "Ocurrió un problema al obtener la orden.",
        showMessage = true
    ) => {

        if (showMessage) {
            setShowTicketAlert(true);
            setTicketMessage(message);
        }

        setStep(1);

        // CONFIG STEP 1
        setShowPassword(false);

        setValidations({});

        setLoadingValidation(false);

        setLoadingText("Validando datos...");

        setShowSuccessAlert(false);

        // CONFIG STEP 2
        setLoadingInvoice(false);

        setLoadingInvoiceText("");

        setTitleGenerateInvoice("");

        setIsStampInvoice(false);

        // CONFIG STEP 3
        setShowDownloadAlert(false);

        setTittlePdf("");

        setLoadingDownload(false);

        setLoadingXml(false);

        // PATIENT
        setValidationsPatient({
            id_tax_regime_patient_valid: false,
            rfc_patient_valid: false,
            cp_patient_valid: false,
            email_valid: false,
            business_name_patient_valid: false,
            id_use_cdfi_valid: false,
        });

        setFormSelfBiling({
            nim: null,
            password: null,
            date: null,
            amount: null,
            sendEmail: true,
            invoice_id: null,
            uuid: null,
            total_stamp: null,
            folio_stamp: null
        });
    };


    // * CONFIGUARTION  STEP 2  ---------

    const GetListTaxRegime = async (is_physical_person = null, is_moral_person = null) => {

        const listRegimes = await getTaxRegimeByTypePerson(is_physical_person, is_moral_person);

        if (listRegimes?.code === 200) {
            const list = listRegimes.data?.map(regime => {
                return {
                    id_tax_regime: regime?.id_tax_regime ?? 0,
                    name: `(${regime?.code ?? ""}) ${regime?.name ?? ""}`,
                    code: regime?.code ?? 0,
                    name_fiscal_regime: regime?.name ?? 0,
                }
            });
            setListTaxRegimes(list);
        }
    }

    const GetListUseCfdi = async (_code = null) => {

        const listUseCFDI = await getUseCfdi(_code);

        if (listUseCFDI?.code === 200) {
            const list = listUseCFDI.data?.map(regime => {
                return {
                    id_use_cdfi: regime?.id_use_cfdi ?? 0,
                    name: `(${regime?.code ?? ""}) ${regime?.description ?? ""}`,
                    code: regime?.code ?? 0,
                    description: regime?.description ?? 0,
                }
            });
            setListUseCFDI(list);
        }
    }

    // ? iINPUTS
    const handleChangeInputEditPatient = async (e) => {

        const { name, value } = e.target;

        setValidationsPatient((prev) => ({
            ...prev,
            [`${name}_valid`]: false,

            ...(name === "id_tax_regime_patient" && {
                id_tax_regime_patient_valid: false
            }),

            ...(name === "email_patient" && {
                email_valid: false
            })
        }));


        switch (name) {

            case "business_name_patient":

                setFormSelfBiling((prev) => ({
                    ...prev,

                    receptor_information: {
                        ...prev.receptor_information,

                        name_commercial_line: value,
                        name_receptor: value
                    }
                }));

                break;


            case "rfc_patient":

                setFormSelfBiling((prev) => ({
                    ...prev,

                    receptor_information: {
                        ...prev.receptor_information,

                        rfc: value.toUpperCase()
                    }
                }));

                break;


            case "type_person_patient":

                setFormSelfBiling((prev) => ({
                    ...prev,

                    receptor_information: {
                        ...prev.receptor_information,

                        type_person: value === "1"
                            ? "FISICA"
                            : "MORAL",

                        tax_regime_id: 0,

                    }
                }));

                await GetListTaxRegime(
                    "4.0",
                    value === "1",
                    value === "2"
                );

                break;


            case "id_tax_regime_patient":

                const taxSelected = listTaxRegimes.find(
                    x => x.id_tax_regime == value
                );

                setFormSelfBiling((prev) => ({
                    ...prev,

                    receptor_information: {
                        ...prev.receptor_information,
                        tax_regime_id: value,
                        code_fiscal_regime: taxSelected?.code || "",
                        name_fiscal_regime: taxSelected?.name_fiscal_regime || ""
                    }
                }));

                await GetListUseCfdi(
                    taxSelected?.code
                );

                break;


            case "cp_patient":

                setFormSelfBiling((prev) => ({
                    ...prev,

                    receptor_information: {
                        ...prev.receptor_information,

                        expedition_place: value
                    }
                }));

                break;

            case "id_use_cdfi":

                const taxSelectedd = listUseCFDI.find(
                    x => Number(x.id_use_cdfi) === Number(value)
                );


                setFormSelfBiling((prev) => ({
                    ...prev,
                    receptor_information: {
                        ...prev.receptor_information,
                        id_use_cdfi: value,
                        code_use_cfdi: taxSelectedd?.code || "",
                        name_use_cfdi: taxSelectedd?.name || ""
                    }
                }));

                break;





            case "email_patient":

                setFormSelfBiling((prev) => ({
                    ...prev,

                    receptor_information: {
                        ...prev.receptor_information,

                        email: value
                    }
                }));

                break;

            default:
                break;
        }
    };

    // ? INFORMATION FISCAL
    const verifyData = async () => {

        let newValidations = {};

        const payload = {

            rfc_patient:
                formSelfBiling?.receptor_information?.rfc,

            business_name_patient:
                formSelfBiling?.receptor_information?.name_commercial_line,

            type_person_patient:
                formSelfBiling?.receptor_information?.type_person,

            tax_regime_id_patient:
                formSelfBiling?.receptor_information?.tax_regime_id,

            id_use_cdfi:
                formSelfBiling?.receptor_information?.id_use_cdfi,

            cp_patient:
                formSelfBiling?.receptor_information?.expedition_place,

            email_patient:
                formSelfBiling?.receptor_information?.email,

            sendEmail_patient:
                formSelfBiling?.sendEmail

        };

        const validations = ValidateFiscalFormPatient(
            payload,
            newValidations
        );

        if (validations.statusValidation) {

            setValidationsPatient(validations.newValidations);

            return;
        }
        else {

            // * CREATE OBJECT INVOICE
            createInvoice()
        }

    }


    // * CREATE INVOICE  ---------------------


    const createInvoice = async () => {

        const body = {
            nim: formSelfBiling?.nim,
            pwd: formSelfBiling?.password,
            commercial_name: formSelfBiling?.receptor_information?.name_commercial_line,
            rfc: formSelfBiling?.receptor_information?.rfc,
            cp: formSelfBiling?.receptor_information?.expedition_place,
            tax_payer: formSelfBiling.receptor_information?.type_person === "FISICA" ? "fisica" : "moral",
            code_tax_regime: formSelfBiling?.receptor_information?.code_fiscal_regime,
            code_use_cfdi: formSelfBiling?.receptor_information?.code_use_cfdi,
            email: formSelfBiling?.receptor_information?.email,
        };

        setValidationsPatient({});

        const messages = [
            "Validando datos fiscales del paciente...",
            "Procesando información fiscal...",
            "Generando estructura de factura...",
            "Enviando solicitud de timbrado...",
            "Generando factura del paciente...",
            "Finalizando proceso..."
        ];

        let index = 0;

        setLoadingInvoice(true);
        setLoadingInvoiceText(messages[index]);
        setTitleGenerateInvoice("No podemos validar la generación de la factura")
        setIsStampInvoice(true)

        const interval = setInterval(() => {
            index = (index + 1) % messages.length;
            setLoadingInvoiceText(messages[index]);
        }, 2500);


        try {

            const sendStamp = await sendStampIngress(body);

            if (sendStamp?.code_invoice === 200) {

                clearInterval(interval);
                setLoadingInvoiceText(
                    "Factura generada correctamente..."
                );
                setTitleGenerateInvoice("")
                setIsStampInvoice(false)
                setLoadingInvoice(false);
                setFormSelfBiling({
                    ...formSelfBiling,
                    uuid: sendStamp?.uuid,
                    folio_stamp: sendStamp?.serie + " " + sendStamp?.folio,
                    id_invoice: sendStamp.num_invoice,
                })
                setStep(3);
            }
            else if (sendStamp?.code_invoice === 500) {
                setTitleGenerateInvoice("No se genero factura");
                setShowTicketAlert(true);

                if (sendStamp?.message === bussineValidation) {
                    setTicketMessage(
                        bussinePatient
                    );
                    setIsStampInvoice(false)

                }
                else if (sendStamp?.message === rfcValidation) {
                    setTicketMessage(
                        rfcPatient
                    );
                    setIsStampInvoice(false)
                }
                else if (sendStamp?.message === cpValidation) {
                    setTicketMessage(
                        cpPatient
                    );
                    setIsStampInvoice(false)
                }
                else {
                    setTicketMessage(
                        "No se llevó a cabo la operación. favor de contactar al laboratorio"
                    );
                    setIsStampInvoice(false)
                }
            }
            else if (sendStamp?.code === 401) {
                setTitleGenerateInvoice("No se genero factura");
                setShowTicketAlert(true);
                setTicketMessage(
                    "No se llevó a cabo la operación. favor de contactar al laboratorio"
                );
                setIsStampInvoice(false);
            }
            else {
                setTitleGenerateInvoice("No se genero factura");
                setShowTicketAlert(true);
                setTicketMessage(
                    "No se llevó a cabo la operación. favor de contactar al laboratorio"
                );
                setIsStampInvoice(false)
            }
        }
        catch (error) {
            console.log(error);
            setShowTicketAlert(true);
            setTicketMessage(
                "Ocurrió un error inesperado."
            );
            setIsStampInvoice(false)

        }
        finally {
            clearInterval(interval);
            setLoadingInvoice(false);
            setIsStampInvoice(false)
        }
    };


    // * STEP 3 GENERATE PDF AND XML  ------------------


    const handleDownloadInvoice = async () => {

        try {

            setLoadingDownload(true);

            const downloadPdf = await DownloadInvoice(
                formSelfBiling?.uuid
            );

            if (downloadPdf?.code === 200) {

                setTittlePdf("PDF descargado");

            } else {

                setTittlePdf(downloadPdf?.msg);
            }

            setShowDownloadAlert(true);

            setTimeout(() => {
                setShowDownloadAlert(false);
            }, 3000);

        } catch (error) {

            console.log(error);

        } finally {

            setLoadingDownload(false);
        }
    };

    const handleDownloadXml = async () => {

        try {

            setLoadingXml(true);

            const result = await DownloadXml(
                formSelfBiling?.id_invoice,
                formSelfBiling?.uuid
            );

            if (result?.code === 200) {

                setTittlePdf("XML descargado");

            } else {

                setTittlePdf(
                    result?.msg || "Error al descargar XML"
                );
            }

            setShowDownloadAlert(true);

            setTimeout(() => {
                setShowDownloadAlert(false);
            }, 2000);

        } catch (error) {

            console.log(error);

            setTittlePdf("Ocurrió un error inesperado");

        } finally {

            setLoadingXml(false);
        }
    };


    return {

        // ? FORM BILING
        formSelfBiling,

        // * STEP 1
        step,
        showPassword,
        setShowPassword,
        handleChangeForm,
        parseDate,
        saveStep1,
        validations,
        loadingValidation,
        loadingText,

        // * STEP 2
        listTaxRegimes,
        handleChangeInputEditPatient,
        validationsPatient,
        verifyData,
        toastBC,
        showTicketAlert,
        ticketMessage,
        setShowTicketAlert,
        showSuccessAlert,
        loadingInvoice,
        loadingInvoiceText,
        titleGenerateInvoice,
        listUseCFDI,

        // * STEP 3
        tittlePdf,
        handleDownloadInvoice,
        showDownloadAlert,
        loadingDownload,
        loadingXml,
        handleDownloadXml,
        isStampInvoice,
        resetInvoiceFlow
    }
}

